import { render, staticRenderFns } from "./add-supplier.vue?vue&type=template&id=4eb82e13&"
import script from "./add-supplier.vue?vue&type=script&lang=js&"
export * from "./add-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports